;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.product-pack.show')
    .controller('ProductPackShowToolbarController', ProductPackShowToolbarController)

  ProductPackShowToolbarController.$inject = [
    // Angular
    '$state',

    // Services
    'DisplayService', 'SnackService',

    // Resolve
    'productPack'
  ]

  function ProductPackShowToolbarController (
    $state,
    DisplayService, SnackService,
    productPack
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {
        label: productPack.label,
        deleteProductPack: deleteProductPack
      })
    }

    function deleteProductPack () {
      DisplayService.confirmDeletion().then(function () {
        productPack.archive().then(function () {
          SnackService.snack({ text: 'Pack produits supprimé !', delay: 5000 })
          $state.go('product-pack.list')
        })
      })
    }
  }
})(window.angular, window._)
